import React from "react";

export default function CheckboxField({ field, value, onChange }) {
  return (
    <div className="mp-form-group pt-checkbox">
      <label>
        <input type="checkbox" checked={!!value} onChange={e => onChange(field.name, e.target.checked)} />
        <span>{field._label}</span>
      </label>
    </div>
  );
}
